export const getGuaranteedPayReport = (state) => {
  return state.guaranateedPayReport;
};

export const getPayPeriodId = (state) => {
  const { payPeriod } = getGuaranteedPayReport(state);
  return (!payPeriod) ? payPeriod : payPeriod.id;
};
